import { Reservation } from '@app/models/micro/reservation.model';
import moment from "moment";
import {ErrorAdapter} from "@models/adapter/error.adapter";
import { IropsRemarkParamsInt } from '@app/interfaces/micro/irops-remark-params.interface';
import { getTypeFlowIrops } from '@app/utils/functions/general';
export class IropsMapper {

  static flights(detailFlight, fareType) {
    if (!detailFlight || !detailFlight._collection || !detailFlight._collection[0] || !detailFlight._collection[0]._collection) {
      return [];
    }

    return detailFlight?._collection[0]?._collection
      .filter((flight) => {
        return this.flightsWithOutCost(flight, fareType);
      })
      .map((flight) => {
        return { ...flight, selected: false }
      });
  }

  static flightsWithOutCost(flight, fareType) {
    let isValid = false;

    const faresCollection = flight?.fares?._collection;

    if (faresCollection.length > 0) {
      const findFare = faresCollection.find((fare) => fare.fareType == fareType);

      if (findFare) {
        isValid = findFare.estimate.currency.total == 0 && (findFare.changeFeeWaived || findFare.priceDifferenceWaived);
      }
    }

    return isValid;
  }


  static mapSelectedRequest(flightSelect) {
    const body = {
      fareChoices: {
        "_meta": {
          "class": "FareChoiceCollection"
        },
        "_collection": [
          {
            "_meta": {
              "class": "FareChoice"
            },
            "segments": {
              "legType": flightSelect.legType,
              "totalFlightTimeInMinutes": flightSelect.totalFlightTimeInMinutes,
              "legCode": flightSelect.legCode,
              "transferSegments": flightSelect.transferSegments,
              "selected": flightSelect.selected,
              "travelersCode": flightSelect.travelersCode,
              "typeFlightMarket": flightSelect.typeFlightMarket,
              "_collection": flightSelect?._collection
            },
            "legFare": flightSelect.fares._collection[0]

          }
        ],
      },
      "legType": flightSelect.segments.legType,
      "totalFlightTimeInMinutes": flightSelect.segments.totalFlightTimeInMinutes,
      "legCode": flightSelect.segments.legCode,
      "transferSegments": flightSelect.segments.transferSegments,
      "selected": flightSelect.segments.selected,
      "travelersCode": flightSelect.travelersCode,
      "typeFlightMarket": flightSelect.typeFlightMarket
    }
    return body
  }


  static mapperResponsePurchase(body, pnr) {
    let response = {
      "_meta": {
        "class": "PurchaseOrder"
      },
      "cartId": pnr.cartId,
      paymentEnabled: 'true',
      "fingerprintSessionId": "aeromexicomivnkmggzw",
      "refund": true,
      "retryCount": 0,
      "3DSRedirectURL": `$https://int.aeromexico.io/es-mx/3ds-reroute?cart=${pnr.cartId}&itinerary=${pnr.cityPairDates}&travelers=${pnr.travelers}&3ds-success=true`,
      "operation": "EXCHANGE",
      "fareChoices": body
    }
    return response
  }

  static mapRespIropsMicro(res) {
    return res;
  }

  static requestIropsMicro(lookUp) {
    let elements = []
    for (let reservation of lookUp) {
      elements.push(reservation.flightSummary.segments.map(segment => {

        return {
          airlineCode: segment.marketingCarrier,
          flight: segment.marketingFlightCode,
          departureDate: segment.departureDateTime.substr(0, 10),
          fareFamily: segment.fareFamily,
          timeZoneId: segment.departureAirportTimeZoneId || segment.timeZoneId,
          origin: segment.departureAirport,
          destination: segment.arrivalAirport,
          legEntity: reservation.flightSummary.legEntity
        };
      }));
    }

    return elements.flat()
  }

  static handleWarnings(response: any): any {
    if (response?.warnings?.length) {
      throw ErrorAdapter.adapt(response.warnings[0]);
    }
    return response;
  }

  static getRquestRemoveCHKN(reservation: Reservation) {
    const { pnr, flightSummary } = reservation
    const [op, flightNumber ] = flightSummary.flightNumber?.split(' ')
    return {
      pnr,
      airline: flightSummary.operatingCarrier,
      departureAirport: flightSummary.departureAirport,
      arrivalAirport: flightSummary.arrivalAirport,
      departureDate: moment(flightSummary.departureDateTime).format('YYYY-MM-DD'),
      flightNumber: flightNumber?.padStart(4, '0'),
    }
  }

  static getResponseRemoveCHKN(response: any) {
    const { warnings } = response;
    if (warnings && warnings.length > 0) {
      let [warning] = warnings
      warning = ErrorAdapter.adapt(warning);
      throw new Error(warning)
    }
    return response
  }

  static getResponseWarningProducts(response: any) {
    const { warnings } = response;
    if (warnings && warnings.length > 0) {
      let [warning] = warnings;
      warning = ErrorAdapter.adapt(warning);
      throw new Error(warning)
    }
    return response
  }

  static mapToWaningsErrors(response: any) {
    let warnings = null;
    const keys = Object.keys(response)
    for(const key of response) {
      const element = response[key];
      const warningsElement = element?.warnings
      if( warningsElement?.length > 0) {
        warnings = warningsElement;
      }
    }
    if (warnings) {
      throw new Error(warnings[0])
    }
    return response

  }

  static getResponseReassociation(response: any) {
    const { warnings } = response;
    if (warnings && warnings.length > 0) {
      let [warning] = warnings
      warning = ErrorAdapter.adapt(warning);
      throw new Error(warning);
    }
    return response;
  }

  static buildRemarkParams(reservation: Reservation, action: string, affectationType: string, flow: string = 'INV'): IropsRemarkParamsInt {
    const currentSegment = reservation.flightSummary?.currentSegment;
    const origin: string = currentSegment?.departureAirport || reservation.flightSummary?.departureAirport || '';
    const destination: string = currentSegment?.arrivalAirport || reservation.flightSummary?.arrivalAirport || '';
    const flowIrops: string = getTypeFlowIrops(reservation);

    return {
      action,
      flow,
      channel: 'KIO',
      window: flowIrops === 'commercial' ? 'CO' : 'OP',
      affectation: affectationType || 'MAJ',
      originDestination: `${origin}${destination}`
    };
  }

  /**
   * Construye la cadena de remark según la estructura:
   * [Action] [Flow] [Channel] [Timestamp] [Window] [Affectation] [IATA Code]
   * Timestamp en formato DDMMYY HHmm (UTC)
   * Todos los campos separados por un espacio.
   */
  static buildIropsRemark(params: IropsRemarkParamsInt): string {
    const {
      action,
      flow,
      channel = 'KIO',
      window,
      affectation,
      originDestination
    } = params;

    const timestamp: string = moment.utc().format('DDMMYY HHmm');

    return [action, flow, channel, timestamp, window, affectation, originDestination].join(' ');
  }

  /**
   * @deprecated Usar buildIropsRemark() con IropsRemarkParamsInt en su lugar.
   */
  static makeSSR(actionIrops?: string, segmentIrops?: string): string {
    if (actionIrops && segmentIrops) {
      return IropsMapper.buildIropsRemark({
        action: actionIrops,
        flow: 'INV',
        channel: 'KIO',
        window: 'OP',
        affectation: 'MAJ',
        originDestination: segmentIrops
      });
    }
    return 'OPERATIONALIROPDELAYEDDIGITAL';
  }
}
